import { render, staticRenderFns } from "./ApiSettings.vue?vue&type=template&id=1b6bc8c5&lang=pug&"
import script from "./ApiSettings.vue?vue&type=script&lang=js&"
export * from "./ApiSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports